import { ISkotningAvstandFilter } from "./ISkotningAvstandFilter";
export class SkotningAvstandFilter implements ISkotningAvstandFilter {
    min?: number;
    max?: number;
}
